module.exports = __webpack_public_path__ + "img/universidadjaveriana-removebg-preview.bb1ec112.png";